export default function Footer() {
  return (
    <footer id="about" className="bg-primary-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid md:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center">
                <i className="ri-store-3-line text-background-50 text-xl" />
              </span>
              <span className="text-xl font-bold text-background-50">全电易</span>
            </div>
            <p className="text-[14px] leading-relaxed text-background-100/80 max-w-md">
              全电易是市场采购贸易(1039)一站式数字化服务平台，提供采购归集、报关申报、阳光收汇、结汇到账与留痕归档，帮助市场商户与小商品卖家无票出口、少门槛、少税负、少风险。
            </p>
          </div>

          <div>
            <h4 className="text-[15px] font-bold text-background-50 mb-4">核心优势</h4>
            <ul className="space-y-3">
              {["无资质出口", "免征不退", "阳光收汇", "简化通关"].map((t) => (
                <li key={t}>
                  <a href="#features" className="text-[14px] text-background-100/80 hover:text-background-50 transition-colors">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[15px] font-bold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-3">
              {[
                { t: "适用场景", href: "#plans" },
                { t: "服务与价格", href: "#pricing" },
                { t: "合规与安全", href: "#compliance" },
                { t: "立即咨询", href: "#contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[14px] text-background-100/80 hover:text-background-50 transition-colors">
                    {l.t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="h-px bg-background-100/15 mb-6" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-background-100/70">
            © 天建产业服务（广东）有限公司. 版权所有
          </p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[13px] text-background-100/70 hover:text-background-50 transition-colors"
          >
            粤ICP备2026082743号-2
          </a>
        </div>
      </div>
    </footer>
  );
}
